import {
  PREVIA_LABEL_FASE,
  PREVIA_LABEL_MES,
  PREVIA_LABEL_PERCENTUAL,
  PREVIA_NOTA,
  PREVIA_TITULO,
} from "../curvas.constants";
import styles from "./previa-mensal.module.scss";
import type { PreviaMensalProps } from "./types-previa-mensal";

export function PreviaMensalView({ nome, fases, id }: PreviaMensalProps) {
  return (
    <div className={styles.previa} id={id} data-testid={id}>
      <h3 className={styles.titulo}>{PREVIA_TITULO}</h3>
      <div className={styles.rolagem}>
        <table className={styles.grade} aria-label={`${PREVIA_TITULO}: ${nome}`}>
          <tbody>
            <tr>
              <th scope="row">{PREVIA_LABEL_FASE}</th>
              {fases.map((fase) => (
                <th key={fase.rotulo} scope="colgroup" colSpan={fase.colunas.length}>
                  {fase.rotulo}
                </th>
              ))}
            </tr>
            <tr>
              <th scope="row">{PREVIA_LABEL_MES}</th>
              {fases.flatMap((fase) =>
                fase.colunas.map((coluna) => (
                  <td key={`${fase.rotulo}-${coluna.mes}`}>{coluna.mes}</td>
                )),
              )}
            </tr>
            <tr>
              <th scope="row">{PREVIA_LABEL_PERCENTUAL}</th>
              {fases.flatMap((fase) =>
                fase.colunas.map((coluna) => (
                  <td key={`${fase.rotulo}-${coluna.mes}`}>{coluna.percentual}</td>
                )),
              )}
            </tr>
          </tbody>
        </table>
      </div>
      <p className={styles.nota}>{PREVIA_NOTA}</p>
    </div>
  );
}
